/*
DO NOT MANUALLY TRANSLATE!
Follow the instructions in the README.md to conveniently update translations.
*/

export default {
  "CookieMessage.old.link": "Meer informatie",
  "CookieMessage.old.text":
    "Om onze webshop goed te laten functioneren maken we gebruik van cookies. Bekijk ons cookiebeleid. ",
  "CookieMessage.link": "Cookies accepteren",
  "CookieMessage.more_information": "Lees meer over Kramp cookies",
  "CookieMessage.return": "Terug",
  "CookieMessage.intro.body":
    "Deze cookies worden door ons en derden geplaatst. Natuurlijk zorgen wij goed voor uw privacy. Indien u hieronder op Cookies accepteren klikt, gaat u akkoord met het gebruik van deze cookies. Het accepteren van cookies zorgt ervoor dat deze website goed werkt. Denk bijvoorbeeld aan:",
  "CookieMessage.intro.list.1": "Automatisch inloggen in Mijn Account",
  "CookieMessage.intro.list.2":
    "Analyse van bezoekersgedrag voor het verbeteren van deze website.",
  "CookieMessage.intro.list.3":
    "Creëren van klantprofielen, zodat we u persoonlijke informatie en advertenties kunnen bieden. ",
  "CookieMessage.intro.extra":
    'Wilt u niet alle cookies accepteren? Dan kunt u dit zelf aanpassen in de <a>instellingen</a>. Lees voor meer informatie onze <a href="{legalLink}">Privacy- en cookieverklaring</a>.',
  "CookieMessage.intro.title": "Kramp maakt gebruik van cookies",
  "CookieMessage.settings.body":
    "U heeft de keuze uit 3 cookie-instellingen. Met de instelling ‘Standaard’ kunnen we u de beste website bieden.",
  "CookieMessage.settings.standard.title": "Standaard (meest gekozen):",
  "CookieMessage.settings.standard.body":
    "Cookies voor inloggen, bestellen, analyse, persoonlijke informatie, social media en cookies van derden.",
  "CookieMessage.settings.restricted.title": "Beperkt:",
  "CookieMessage.settings.restricted.body":
    "Cookies voor inloggen, bestellen, analyse en persoonlijke informatie.",
  "CookieMessage.settings.highly_restricted.title": "Zeer beperkt:",
  "CookieMessage.settings.highly_restricted.body":
    "U laat zo min mogelijk cookies toe. Alleen voor inloggen, bestellen en een redelijk werkende website.",
  "CookieMessage.settings.options.title": "Wat we doen:",
  "CookieMessage.settings.option.1":
    "Cookies gebruiken zodat deze website goed werkt",
  "CookieMessage.settings.option.2": "Gebruikersonderzoek",
  "CookieMessage.settings.option.3": "Persoonlijke statistieken bijhouden",
  "CookieMessage.settings.option.4": "Interessante informatie laten zien",
  "CookieMessage.settings.option.5": "Informatie gebruiken voor advertenties",
  "CookieMessage.settings.option.6": "Anonieme statistieken bijhouden",
  "CookieMessage.settings.option.7": "Je persoonlijke gegevens delen",
  "CookieMessage.settings.title": "Cookie instellingen",
  "CookiePage.url": "privacy-policy-cookies",
};
